import { Link as GatsbyLink } from 'gatsby';
import {styled, alpha } from '@mui/material';

// Styled Link component with hover effect
export const Link = styled(GatsbyLink)(({ theme }) => ({
    borderRadius    : theme.spacing(1),
    padding         : theme.spacing(1),
    textDecoration  : 'none', // Remove underline
    transition      : 'background-color 0.3s ease', // Smooth transition for background color change
    '&:hover' : {
        backgroundColor : alpha(theme.palette.primary.main,0.5), // Change background color on hover to secondary dark color
    },
}));

export default Link;